/* ============================================================
   MAYIILANG : pulsation de l'icône panier (1er nov. 2026)
   Dès qu'un client ajoute un article au panier, l'icône panier de
   l'en-tête pulse 4 fois (halo jaune ylang, même effet que sur le
   tissu choisi de la fiche produit), puis se calme. Le rappel
   (4 pulsations) revient à chaque nouvelle page visitée, jusqu'à ce
   que le client :
   - clique sur l'icône panier,
   - ou ouvre la page panier (bouton « Voir le panier »...),
   - ou vide son panier.
   Il s'arrête aussi quand le client ferme son navigateur (mémoire
   de session). Couleurs et rythme : assets/mayi-panier-pulse.css.
   Footer (téléphone et tablette) : le « + » du menu « Informations »
   pulse 3 fois (halo blanc) quand le footer arrive à l'écran, tant
   que le client n'a pas ouvert ce menu. Une fois ouvert, il ne pulse
   plus jusqu'à la fermeture du navigateur.
   ============================================================ */
(function () {
  var CLE = 'mayi-panier-pulse';
  var CLASSE = 'mayi-panier-pulse';

  function lire() {
    try { return sessionStorage.getItem(CLE) === '1'; } catch (e) { return false; }
  }
  function ecrire(v) {
    try {
      if (v) sessionStorage.setItem(CLE, '1');
      else sessionStorage.removeItem(CLE);
    } catch (e) {}
  }

  var actif = lire();

  function appliquer() {
    var icone = document.getElementById('cart-icon-bubble');
    if (icone) icone.classList.toggle(CLASSE, actif);
  }
  function demarrer() {
    actif = true;
    ecrire(true);
    /* Nouvel ajout : on relance les 4 pulsations. */
    var icone = document.getElementById('cart-icon-bubble');
    if (icone) {
      icone.classList.remove(CLASSE);
      void icone.offsetWidth;
    }
    appliquer();
    /* L'icône est redessinée par le thème juste après l'ajout. */
    setTimeout(appliquer, 400);
    setTimeout(appliquer, 1200);
  }
  function arreter() {
    actif = false;
    ecrire(false);
    appliquer();
  }

  /* Ajout au panier : on repère toute demande /cart/add réussie
     (bouton « Ajouter au panier », ajout rapide...). */
  if (window.fetch) {
    var fetchOrigine = window.fetch;
    window.fetch = function (ressource) {
      var url = typeof ressource === 'string' ? ressource : (ressource && ressource.url) || '';
      var promesse = fetchOrigine.apply(this, arguments);
      if (/\/cart\/add/.test(url)) {
        promesse.then(function (r) { if (r && r.ok) demarrer(); }).catch(function () {});
      }
      return promesse;
    };
  }

  /* Le client regarde son panier : on arrête. */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#cart-icon-bubble')) arreter();
  }, true);

  function auChargement() {
    if (/\/cart\/?$/.test(location.pathname)) { arreter(); return; }
    appliquer();
    if (!actif) return;
    /* Panier vidé entre-temps : plus de pulsation. */
    var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetchOrigine && fetchOrigine(racine + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (!c || !c.item_count) arreter(); })
      .catch(function () {});
  }

  /* Footer : « + » du menu « Informations ». */
  var CLE_INFO = 'mayi-info-vu';
  function infoVu() {
    try { return sessionStorage.getItem(CLE_INFO) === '1'; } catch (e) { return false; }
  }
  function initInfo() {
    var menus = document.querySelectorAll('.mf__info');
    for (var i = 0; i < menus.length; i++) {
      (function (menu) {
        if (!infoVu()) {
          /* Les 3 pulsations partent quand le menu est bien visible. */
          if ('IntersectionObserver' in window) {
            var obs = new IntersectionObserver(function (entrees) {
              if (!entrees[0].isIntersecting) return;
              obs.disconnect();
              if (!infoVu()) menu.classList.add('mayi-info-pulse');
            }, { threshold: 0.6 });
            obs.observe(menu);
          } else {
            menu.classList.add('mayi-info-pulse');
          }
        }
        menu.addEventListener('toggle', function () {
          if (!menu.open) return;
          try { sessionStorage.setItem(CLE_INFO, '1'); } catch (e) {}
          for (var j = 0; j < menus.length; j++) menus[j].classList.remove('mayi-info-pulse');
        });
      })(menus[i]);
    }
  }

  function demarrage() {
    auChargement();
    initInfo();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrage);
  else demarrage();
})();
